<template>
  <div>
    <b-card class="w-100 pt-0 pb-0 border-0">
      <vue-easy-lightbox
        escDisabled
        moveDisabled
        :visible="visibleSpaceImg"
        :index="imgIndex"
        :imgs="rentedSpacesSignedUrl"
        @hide="visibleSpaceImg = false"
      ></vue-easy-lightbox>
      <div :class="[auditStoreInfoSpaceRented.length >=3 ? 'collateral-scroll':'']">
        <div class="w-100 border-bottom mb-1" :key="index" v-for="(space, index) in auditStoreInfoSpaceRented">
          <div  class="ts-12 fw-400 mb-1 float-end">₱ {{ space.amount | toCurrency }}</div>
          <div class="ts-14 text-capitalize fw-700 mb-1">{{ space.type }}</div>
          <div class="ts-12 fw-400 mb-1">{{ space.placement }}</div>
          <!-- <div class="ts-12 fw-400 mb-1">Size: {{ space.dimension }}</div> -->
          <!-- <div class="ts-12 fw-400 mb-1 text-danger" v-if="isCancelled(space)">Cancellation Fee: {{ space.cancelled.fee }}</div> -->
          <!-- <div  class="ts-12 fw-400 mb-1" v-if="true">Available for {{ space.duration }} month{{ space.duration > 1 ? "s" : "" }}</div> -->
          <div class="ts-12 fw-400 mb-1 text-primary c-pointer" @click="visibleSpaceImg = true;imgIndex = index;">View Image</div>
        </div>
      </div>
      <!-- <div class="pt-2 ts-14 fw-700">
        <div class="float-start">Total</div>
        <div style="text-align: right;" :key="index" v-for="(space, index) in auditStoreInfoSpaceRented">
          <span class="text-success">₱ {{space.amount | toCurrency}}/Month</span><br>
          <small>₱ {{space.amount | toCurrency}} * {{ space.duration }} month{{ space.duration > 1 ? 's':'' }} = ₱ {{space.amount * space.duration | toCurrency}}</small>
        </div>
      </div> -->
      <!--end of total-->
      <!-- <hr />
      <div class="pt-2 ts-16">
        <div class="fw-700">
          <div class="float-end">₱ {{forHolding - totalRelease | toCurrency}}</div>
          For Holding
        </div>
        <small>
          <div class="float-end">₱ {{totalRelease | toCurrency}}</div>
          Total Release
        </small>
      </div>
      <hr> -->
      <!-- <div class="d-flex align-items-center justify-content-center">
        <span class="float-start me-2 ts-30 text-info">
          <i class="bx bx-info-circle"></i>
        </span>
        <span class="ts-10">
          Audits will be done monthly. Failure to answer the request form within 5 days, will result in automatically transferring the money.
        </span>
      </div> -->
    </b-card>

    <b-card class="w-100 pt-0 pb-0 border-0">
      <div class="text-capitalize row">
        <div class="col-3"><b>Status:</b></div>
        <div class="col-9">
          <div class=" overflow-auto" v-html="auditStoreStatus.status" v-if="auditStoreStatus.color == 'cancel'"></div>
          <span class="float-end" :class="[auditStoreStatus.color]" v-else>{{ auditStatus }}</span>
        </div>
      </div>
      <p :key="index" v-for="(item, index) in auditStoreStatus.trail" class="mb-1 ts-12">
        <span class="float-end">{{ item.date | formatDate }} </span>
        <span class="">{{ item.action }}: </span>
      </p>
    </b-card><!--end of status-->

    <b-card class="w-100 pt-0 pb-0 border-0">
      <div class="stepwizard">
        <div class="stepwizard-row">
          <div class="stepwizard-step">
            <button type="button" class="btn btn-circle" :class="[auditShipStatus.prepared_at != null ? 'btn-primary':'btn-secondary']"><i class="bx bx-package ts-18"></i></button>
            <p>
              Preparing Shipment<br>
              <small class="text-muted">{{auditShipStatus.prepared_at | formatDate}}</small>
            </p>
          </div>
          <div class="stepwizard-step">
            <button type="button" class="btn btn-circle css-reverse pt-0" :class="[auditShipStatus.ship_at != null ? 'btn-primary':'btn-secondary']"><i class="uil-truck ts-18"></i></button>
            <p>
              Collateral in Transit<br>
              <small class="text-muted">{{auditShipStatus.ship_at | formatDate}}</small>
            </p>
          </div>
          <div class="stepwizard-step">
            <button type="button" class="btn btn-circle pt-0" :class="[auditTimeline.length> 0 && auditShipStatus.delivered_at != null ? 'btn-primary':'btn-secondary']"><i class="uil-envelope-check ts-18"></i></button>
            <p>
              Collateral Delivered<br>
              <small class="text-muted" v-if="auditTimeline.length> 0">{{auditShipStatus.delivered_at | formatDate}}</small><br>
              <span class="ts-12 fw-400 mb-1 text-primary c-pointer" v-if="auditTimeline.length> 0 && auditShipStatus.delivered_at != null" @click="visibleSpaceImg = true;imgIndex = viewImageReceived;">View Image</span>
            </p>
          </div> 
        </div>
      </div>
      <button type="button" class="btn btn-primary btn-block w-100" v-if="auditShipStatus.ship_at == null" @click="openModal('bv-modal-shipping-form')">
        Ship out
      </button>
      <hr>
      <!-- <p class="mb-1">
        <span class="float-end text-capitalize"> {{auditShipStatus.courierName}} </span>
        <span class="">Courier Name: </span>
      </p>
      <p class="mb-1">
        <span class="float-end"> {{auditShipStatus.trackingNumber}} </span>
        <span class="">Tracking Number: </span>
      </p> -->
      <!-- <hr> -->
      <!-- <p class="text-primary" @click="openModal('bv-modal-collateral')">How to Shipped Collaterals</p> -->
      <div class="d-flex align-items-center justify-content-center" v-if="false">
        <span class="float-start me-2 ts-30 text-info">
          <i class="bx bx-info-circle"></i>
        </span>
        <span class="ts-10">
          You have 15 days to prepare the marketing collaterals. You have until [Date Given]
        </span>
      </div>

      <b-modal id="bv-modal-collateral" title="How to ship collaterals" size="md" hide-header hide-title hide-footer hide-header-close>
        <span class="float-end c-pointer " @click="closeModal('bv-modal-collateral')"><i class="bx bx-x"></i></span>
        <div class="row p-2 mt-4">
          <div class="col-12 d-flex align-items-center justify-content-center my-3 css-reverse">
            <i style="font-size: 50px;" class="uil-truck text-primary"></i>
          </div>
          <div class="col-12 text-center">
            <p style="font-family: Poppins;
              font-size: 24px;
              font-weight: 500;
              ">How to Ship Collaterals</p>
          </div>
          <div class="col-12 mt-2">
            <p class="mb-0">
              <span class="text-primary me-2">Step 1:</span>
              <span class="fw-semibold">Process the order</span>
            </p>
            <p class="ts-12 mt-0">Create/produce collaterals that need to be shipped. Ensure that they are properly printed and well-organized for shipping.</p>
            <p class="mb-0">
              <span class="text-primary me-2">Step 2:</span>
              <span class="fw-semibold">Prepare packaging materials</span>
            </p>
            <p class="ts-12 mt-0">Ensure you prepare the appropriate size box for the collaterals. Prepare sturdy boxes and bubble wraps for added protection.</p>
            <p class="mb-0">
              <span class="text-primary me-2">Step 3:</span>
              <span class="fw-semibold">Package the order</span>
            </p>
            <p class="ts-12 mt-0">Place the collateral carefully in the box. The package must be tightly packed to prevent damage and movement during shipping. If not, fill in the empty spaces with filling materials (paper, Styrofoam balls, bubble wrap, etc.).</p>
            <p class="mb-0">
              <span class="text-primary me-2">Step 4:</span>
              <span class="fw-semibold">Label and seal the package</span>
            </p>
            <p class="ts-12 mt-0">Label the package with the necessary information, such as the recipient's name, address, and contact details. Secure the package with tape to prevent accidental openings.</p>
            <p class="mb-0">
              <span class="text-primary me-2">Step 5:</span>
              <span class="fw-semibold">Ship the package</span>
            </p>
            <p class="ts-12 mt-0">Choose a reliable shipping provider. Take your package to the shipping provider and have it delivered to the recipient. Ensure that you take note of the tracking number and enter it into the Shipping Details section via Audit Space.</p>
          </div>
        </div>
      </b-modal>
      <b-modal id="bv-modal-shipping-form" title="Shipping Details" size="md" hide-header hide-title hide-footer hide-header-close>
        <span class="float-end c-pointer " @click="closeModal('bv-modal-shipping-form')"><i class="bx bx-x"></i></span>
        <h5>Shipping Details</h5>
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form
            ref="collateralSetupForm"
            @submit.prevent="handleSubmit(submitShippingDetails)"
            @reset.prevent="reset"
          >
            <b-form-group class="mt-4 ts-14">
              <label>Tracking Number <span class="text-danger">*</span></label>
              <validation-provider
                name="tracking number"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-input
                  :state="getValidationState(validationContext)"
                  placeholder="Enter Tracking Number"
                  v-model="form.tracking_no"
                  trim
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <b-form-group class="mt-4 ts-14">
              <label>Courier Name <span class="text-danger">*</span></label>
              <validation-provider
                name="courier name"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-input
                  :state="getValidationState(validationContext)"
                  placeholder="Enter Courier Name"
                  v-model="form.courier_name"
                  trim
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <div class="mt-2">
              <b-button
                class="float-end"
                type="submit"
                variant="primary"
                :disabled="isSubmitted"
              >
                <span
                  v-if="isSubmitted"
                  class="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Submit
              </b-button>
              <b-button
                class="float-end me-2"
                type="button"
                variant="secondary"
                @click="closeModal('bv-modal-shipping-form')"
              >
                close
              </b-button>
            </div>
          </b-form>
        </ValidationObserver>
      </b-modal>
    </b-card><!--end of ship collateral-->
  </div>
</template>

<script>
import {auditSpaceComputed, auditSpaceMethods } from "@/state/helpers"
import { Storage } from "aws-amplify";

export default {
  props: ["value"],
  comments:{},
  data() {
    return {
      form: {tracking_no:null,courier_name:null},
      isSubmitted:false,
      visibleSpaceImg: false,
      imgIndex: 0,
    };
  },
  computed: {
    ...auditSpaceComputed
  },
  methods: {
    ...auditSpaceMethods,
    openModal(modal=''){
      this.form= {tracking_no:null,courier_name:null}
      this.$bvModal.show(modal);
    },
    closeModal(modal=''){
      this.$bvModal.hide(modal);
    },
    async submitShippingDetails(){
      // console.log(">>>>> ",JSON.stringify(this.form));
      this.isSubmitted = true;

      await this.fetchStoreShipOut({...this.form,"campaignDtlId":this.$route.params.pid}).then((result)=>{
        console.log(result);
        this.isSubmitted = false;
        this.$toast.showToast(
          "success" , 
          "Success!" , 
          "Shipping Details has been submitted.");
        this.closeModal('bv-modal-shipping-form');
        this.fetchStoreSpaceInfo({"campaignDtlId":this.$route.params.pid})
      }).catch(()=>{
        setTimeout(() => {
          this.isSubmitted = false;
        }, 1500);
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    isValidHttpUrl(string) {
      let url;
      
      try {
        url = new URL(string);
      } catch (_) {
        return false;  
      }

      return url.protocol === "http:" || url.protocol === "https:";
    },
    isCancelled(space){
      var visible = false;
      if(Object.prototype.hasOwnProperty.call(space,"cancelled")){
        if(space.cancelled.status == "approved"){
          visible = true
        }
      }
      return visible;
    }
  },
  asyncComputed: {
    async forHolding() {
      var value = 0
      for (let k of this.auditStoreInfoSpaceRented) {
        value += k.subTotal
      }
      return value;
    },
    async totalRelease() {
      var value = 0
      for (let k of this.auditStoreInfoSpaceRented) {
        value += k.totalRelease
      }
      return value;
    },
    async rentedSpacesSignedUrl() {
      var keys = this.auditStoreInfoSpaceRented.map((s) => s.photoSpace),
        audit_keys = this.auditTimeline.map((s) => s.images),
        signed = [];

      // console.log(">>>>> hey rentedSpacesSignedUrl", keys);
      for (let k of keys) {
        if(this.isValidHttpUrl(k)){
          signed.push(k);
        }else if(k.length > 2){
          signed.push(await Storage.get(k, { level: "public" }));
        }else{
          signed.push(k);
        }
      }
      for(let ak of audit_keys){
        if(this.isValidHttpUrl(ak[0])){
          signed.push(ak[0]);
        }else if(ak[0].length > 2){
          signed.push(await Storage.get(ak[0], { level: "public" }));
        }else{
          signed.push(ak[0]);
        }
      }

      return signed;
    },
    async auditStatus() {
      try {
        var s = this.auditStoreStatus.status,
            r = [{s:"toShip",t:"pending to shipment"},{s:"shipping",t:"collateral in transit"},{s:"shipped",t:"collateral delivered"},{s:"received",t:"collateral received"}];

        for(let i of r){
          if(s === i.s){
            return i.t;
          }
        }
        return s;
      } catch (error) {
        return "";
      }
    },
    async viewImageReceived() {
      var index = (this.auditStoreInfoSpaceRented.length - 1);
      try {
        for(let i of this.auditTimeline){
          index++;
          if(i.mobileStatus.length > 2){
            break
          }
        } 
      } catch (error) {
        console.log("viewImageReceived", error);
      }
      return index;
    },
  },
};
</script>

<style>
.text-pending{
  color: #A50E63;
}


.stepwizard-step p {
    margin-top: 10px;
    font-size: 13px; 
}

.stepwizard-row {
    display: table-row;
}

.stepwizard {
    display: table;     
    width: 100%;
    position: relative;
}

.stepwizard-step button[disabled] {
    opacity: 1 !important;
    filter: alpha(opacity=100) !important;
}

.stepwizard-row:before {
    top: 14px;
    bottom: 0;
    position: absolute;
    content: " ";
    margin-left:20%;
    width: 60%;
    height: 1px;
    background-color: #ccc;
    z-order: 0;
    
}

.stepwizard-step {    
    display: table-cell;
    text-align: center;
    position: relative;
}

.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}

.collateral-scroll{
  max-height: 375px;
  overflow-y: scroll;
}
</style>

